import * as React from 'react';

import { FilterDropdown } from 'components/tailwind-ui/FilterDropdown';
import { GenericSearch } from 'components/PillSearch';
import { useFilterSearchParams } from '../../hooks';

export const Containers: React.FC = () => {
  const { searchParams, setSearchParams } = useFilterSearchParams(true);
  const clear = () => setSearchParams({ containerNumbers: [] });
  return (
    <FilterDropdown
      label="Container #"
      className="p-1"
      count={searchParams.containerNumbers.length}
      clear={clear}
    >
      <GenericSearch
        onSearch={(values) => setSearchParams({ containerNumbers: values })}
        inputValues={searchParams.containerNumbers}
        maximum={100}
        placeholder="Filter by container numbers"
        variant="simple"
        className="w-[300px]"
      />
    </FilterDropdown>
  );
};
Containers.displayName = 'Shipments.AddContainers.RecentlyAdded.Filters.Containers';
